import React, { useState } from 'react'
import * as yup from 'yup'
import _ from 'lodash'
import { Form, Formik } from 'formik'
import useTrans from '@hooks/useTrans'
import { FormikFieldProps } from '@components/atoms/FormikField/FormikField'
import { Button, FormikField, FormLayout } from '@components/atoms'
import styles from './FormHandler.module.sass'

export type FormHandlerConfItemType =
  | (Omit<FormikFieldProps, 'type'> & {
      type: FormikFieldProps['type']
      children?: FormHandlerConfItemType[]
      initialValue?: string
      validation?: { email?: boolean }
      isVisible?: (v) => boolean
    })
  | {
      type: 'group'
      label?: string
      layout: FormikFieldProps['layout'] | ((v) => FormikFieldProps['layout'])
      children: FormHandlerConfItemType[]
    }

interface Props {
  prefix?: string
  conf?: FormHandlerConfItemType[]
  submitLabel?: string
  onSubmit?: (v: any) => void
  validationSchema?: any
  className?: string
}

const FormHandler = (props: Props) => {
  const {
    prefix = undefined,
    conf = undefined,
    submitLabel = undefined,
    onSubmit = undefined,
    validationSchema = undefined,
    className = '',
  } = props

  const t = useTrans()
  const [submitClicked, setSubmitClicked] = useState(false)
  const getInitialValues = (fieldConf) =>
    fieldConf.type === 'group'
      ? (fieldConf.children || [])?.reduce((r, x) => ({ ...r, ...getInitialValues(x) }), {})
      : {
          [fieldConf.name]:
            fieldConf?.initialValue || (fieldConf.type === 'checkbox' ? false : undefined),
        }

  const initialValues = conf.reduce((res, x) => ({ ...res, ...getInitialValues(x) }), {})

  // const buildValidationType = (validation, fieldConf, validationType) => {
  //   switch (validationType) {
  //     case 'field_type':
  //       switch (fieldConf.type) {
  //         case 'checkbox':
  //           return (validation || yup).bool(t("Dev'essere un boolean"))
  //         default:
  //           return (validation || yup).string(t("dev'essere string"))
  //       }
  //     case 'required':
  //       if (fieldConf.required) {
  //         return fieldConf.type === 'checkbox'
  //           ? (validation || yup)
  //               .oneOf([true], t('Questo campo è obbligatorio'))
  //               .required(t('Questo campo è obbligatorio'))
  //           : (validation || yup).required(t('Questo campo è obbligatorio'))
  //       }
  //     case 'email':
  //       if (fieldConf.validation?.email)
  //         return (validation || yup).email(t("Il formato dell'email dev'essere valido"))
  //   }
  //   return validation
  // }

  // const buildFieldValidation = (fieldConf) => {
  //   const validationTypes = ['field_type', 'required', 'email']
  //   let validation = undefined
  //   validationTypes.forEach((validationType) => {
  //     const fieldValidation = buildValidationType(validation, fieldConf, validationType)
  //     if (fieldValidation) validation = fieldValidation
  //   })
  //   return validation
  // }

  // const buildValidationSchemaShape = (groupConf) =>
  //   groupConf.reduce((res, x) => {
  //     if (x.type === 'group') {
  //       const childrenValidationSchemaShape = buildValidationSchemaShape(x.children)
  //       return childrenValidationSchemaShape ? { ...res, ...childrenValidationSchemaShape } : res
  //     } else {
  //       const fieldValidation = buildFieldValidation(x)
  //       return fieldValidation
  //         ? {
  //             ...res,
  //             [x.name]: buildFieldValidation(x),
  //           }
  //         : res
  //     }
  //   }, {})

  // const validationSchemaShape = buildValidationSchemaShape(conf)
  // const validationSchema = yup.object().shape(validationSchemaShape)

  const renderField = (fieldConf, formikProps, idx) => (
    <React.Fragment key={idx}>
      {fieldConf.type === 'group' ? (
        fieldConf.children?.length || fieldConf.label ? (
          <div className={styles.group}>
            {!!fieldConf.label && (
              <div
                className={styles.groupLabel}
                dangerouslySetInnerHTML={{ __html: fieldConf.label }}
              />
            )}
            {!!fieldConf.children?.length && (
              <div className={styles.groupList}>
                {fieldConf.children.map((c, cidx) => renderField(c, formikProps, cidx))}
              </div>
            )}
          </div>
        ) : (
          <></>
        )
      ) : !fieldConf.isVisible || fieldConf.isVisible(formikProps.values) ? (
        <FormikField
          formik={formikProps}
          id={`${prefix ? `${prefix}_` : ''}${fieldConf.name}`}
          showErrors={submitClicked}
          {...(_.omit(fieldConf, ['initialValue', 'isVisible', 'layout']) as Omit<
            FormikFieldProps,
            'initialValue'
          >)}
          layout={
            fieldConf.layout
              ? typeof fieldConf.layout === 'function'
                ? fieldConf.layout(formikProps.values)
                : fieldConf.layout
              : undefined
          }
        />
      ) : (
        <></>
      )}
    </React.Fragment>
  )

  return conf ? (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        if (onSubmit) onSubmit(values)
      }}
      className={`${styles.root} ${className}`}
    >
      {(formikProps) => (
        <Form className={styles.form}>
          <FormLayout>{conf.map((x, idx) => renderField(x, formikProps, idx))}</FormLayout>
          <div className={styles.submit}>
            <Button
              label={submitLabel}
              type="submit"
              loading={formikProps.isSubmitting}
              onClick={() => setSubmitClicked(true)}
            />
          </div>
        </Form>
      )}
    </Formik>
  ) : (
    <></>
  )
}

export default FormHandler
